var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PageNames } from '../../shared/page-names.enum';
import { NavigationService } from '../../services/navigation/navigation.service';
import { TvShopEntertainmentPack } from '../../model/tv-shop-entertainment-pack';
import { PriceUtils } from '../../shared/utils/price/price.utils';
import { Router } from '@angular/router';
import { OrderingModalManagerComponent } from '../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { BaseActions } from '../../shared/base-actions';
import { LanguageService } from '../../services/language/language.service';
import { ImageUtils } from '../../shared/utils/image/image-utils';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var DeepLinkingOptionComponent = /** @class */ (function (_super) {
    __extends(DeepLinkingOptionComponent, _super);
    function DeepLinkingOptionComponent(navigationService, router, languageService, stateService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.router = router;
        _this.languageService = languageService;
        _this.stateService = stateService;
        _this.ownerComponent = PageNames.DEEP_LINKING;
        return _this;
    }
    DeepLinkingOptionComponent.prototype.getLogoUrl = function () {
        return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
    };
    DeepLinkingOptionComponent.prototype.activate = function (active) {
        this.active = active;
    };
    DeepLinkingOptionComponent.prototype.canNavigateToDirection = function (keyCode) {
        return true;
    };
    DeepLinkingOptionComponent.prototype.onBack = function () {
        this.navigationService.resetPage();
        window.close();
    };
    DeepLinkingOptionComponent.prototype.emitOnEnterPressed = function (event) {
        this.order = event;
        this.openOrderModal();
    };
    DeepLinkingOptionComponent.prototype.onEnter = function () {
    };
    DeepLinkingOptionComponent.prototype.navigateToDetailPage = function () {
        this.stateService.setSelectedTvShopEntertainmentPack(this.pack);
        this.router.navigateByUrl('/product-details/' + this.omapiId + '?' + 'origin=deeplink');
    };
    DeepLinkingOptionComponent.prototype.openOrderModal = function () {
        this.orderingModal.openModal();
    };
    DeepLinkingOptionComponent.prototype.productName = function () {
        return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.omapiId);
    };
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "hasPromo", {
        get: function () {
            return this.pack && this.pack.priceDetail && this.pack.priceDetail.hasPromo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "promoLabel", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoLabel : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "promoDuration", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoDuration : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "textIntegerPart", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.price.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "textDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this.pack && this.pack.priceDetail ? this.pack.priceDetail.price.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "priceBeforeComma", {
        get: function () {
            return this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoPrice.integerPart() : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "getPriceTextDecimalPart", {
        get: function () {
            return this.getTextDecimalPart(this.pack && this.pack.priceDetail ? this.pack.priceDetail.promoPrice.decimalPart() : undefined);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "rscOmapiId", {
        get: function () {
            return OmapiIdsUtils.getCorrectIdForResource(this.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    DeepLinkingOptionComponent.prototype.isSelectable = function () {
        return true;
    };
    DeepLinkingOptionComponent.prototype.isSubscribed = function () {
        return false;
    };
    Object.defineProperty(DeepLinkingOptionComponent.prototype, "currentLang", {
        get: function () {
            return this.languageService.getCurrentLanguage().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    DeepLinkingOptionComponent.prototype.getTextDecimalPart = function (price) {
        return PriceUtils.prefixDecimalPart(price, this.currentLang);
    };
    return DeepLinkingOptionComponent;
}(BaseActions));
export { DeepLinkingOptionComponent };
